// v3.0.0-rc.8h — Presence Chime : petit son doux (Web Audio API, zero asset).
// Joué la PREMIÈRE fois du jour qu'un commerçant favori repasse en ligne.
// Verrouillé sur `aya_presence_chime_YYYY-MM-DD_<phone>` en localStorage.

let _ctx = null;
function _ac() {
  if (_ctx) return _ctx;
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    _ctx = new AC();
    return _ctx;
  } catch (_) { return null; }
}

function _todayKey() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const phone = (localStorage.getItem("civ_user_phone") || "anon").replace(/\W/g, "");
  return `aya_presence_chime_${y}-${m}-${dd}_${phone}`;
}

// Joue deux notes très courtes (do 523.25 Hz puis mi 659.25 Hz), volume bas.
function _playChime() {
  const ctx = _ac();
  if (!ctx) return;
  try {
    if (ctx.state === "suspended") ctx.resume().catch(() => {});
    const now = ctx.currentTime;
    [
      { f: 523.25, t: now, dur: 0.18 },
      { f: 659.25, t: now + 0.16, dur: 0.24 },
    ].forEach(({ f, t, dur }) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.setValueAtTime(f, t);
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.14, t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t);
      osc.stop(t + dur + 0.02);
    });
  } catch (_) { /* silent */ }
}

/**
 * Tente de jouer le chime :
 *   - Une seule fois par jour et par utilisateur (localStorage).
 *   - Silencieux si l'AudioContext n'est pas autorisé (autoplay policy) —
 *     dans ce cas le chime jouera au prochain event après un click user.
 */
export function playPresenceChimeIfFirstOfDay() {
  try {
    const k = _todayKey();
    if (localStorage.getItem(k) === "1") return false;
    localStorage.setItem(k, "1");
    _playChime();
    return true;
  } catch (_) { return false; }
}
